module.exports = __webpack_public_path__ + "img/分区07.880ad9f7.png";